module.exports = "/static/media/exclamation.22a812e8.svg";